export default "__VITE_ASSET__BtzNia8f__"